module.exports = __webpack_public_path__ + "img/label.087d0046.svg";